export const DIMENSION_UNIT_SYSTEM = Object.freeze({
  US: "us",
  METRIC: "metric",
});

export const BUILDING_DIMENSION_FIELDS = Object.freeze({
  clearHeight: "clearHeight",
  buildingDepth: "buildingDepth",
  buildingLength: "buildingLength",
  typicalColumnSpacing2: "columnSpaceDepth",
  typicalColumnSpacing1: "columnSpaceLength",
  speedBayDepth: "speedBayDepthFront",
  backSpeedBayDepthMeasurement: "speedBayDepthBack",
  truckCourtDepth: "truckCourtDepthFront",
  backTruckCourtDepthMeasurement: "truckCourtDepthBack",
});

export const BUILDING_DIMENSION_LABEL_KEYS = Object.freeze({
  clearHeight: "Dimensions.ClearHeight",
  buildingDepth: "Dimensions.BuildingDepth",
  buildingLength: "Dimensions.BuildingLength",
  typicalColumnSpacing2: "Dimensions.ColumnSpaceDepth",
  typicalColumnSpacing1: "Dimensions.ColumnSpaceLength",
  speedBayDepth: "Dimensions.PrimarySpeedBayDepth",
  backSpeedBayDepthMeasurement: "Dimensions.SecondarySpeedBayDepth",
  truckCourtDepth: "Dimensions.PrimaryTruckCourtDepth",
  backTruckCourtDepthMeasurement: "Dimensions.SecondaryTruckCourtDepth",
});

const hasFormattedUnitBlock = dimension => Boolean(dimension?.us?.formatted || dimension?.metric?.formatted);

export const hasBuildingDimensionValues = dimensions =>
  Object.values(BUILDING_DIMENSION_FIELDS).some(field => hasFormattedUnitBlock(dimensions?.building?.[field]));

export const hasUnitDimensionValues = dimensions =>
  (dimensions?.units || []).some(unit => hasFormattedUnitBlock(unit.clearHeight));

export const getDimensionRequestDisplayState = ({ completedPropertyId, dimensions, error, isLoading, propertyId }) => {
  const isCurrentPropertyComplete = completedPropertyId === propertyId;

  return {
    dimensions: isCurrentPropertyComplete ? dimensions : null,
    error: isCurrentPropertyComplete ? error : null,
    isCurrentPropertyComplete,
    isLoading: isLoading || !isCurrentPropertyComplete,
  };
};

export const getSelectedDimensionBlock = (dimension, selectedUnitSystem) => dimension?.[selectedUnitSystem] || null;

const pluralize = (value, singular, plural) => `${value} ${value === 1 ? singular : plural}`;

export const getDimensionAriaLabel = (dimension, selectedUnitSystem) => {
  const selectedBlock = getSelectedDimensionBlock(dimension, selectedUnitSystem);
  if (!selectedBlock) return undefined;

  if (selectedUnitSystem === DIMENSION_UNIT_SYSTEM.METRIC) {
    return `${pluralize(selectedBlock.meters, "meter", "meters")} ${pluralize(
      selectedBlock.centimeters,
      "centimeter",
      "centimeters",
    )}`;
  }

  return `${pluralize(selectedBlock.feet, "foot", "feet")} ${pluralize(selectedBlock.inches, "inch", "inches")}`;
};

export const findUnitDimensions = (dimensions, unitId) =>
  (dimensions?.units || []).find(unit => unit.unitId === unitId);
